import React from "react";
import WeatherIcon from "./WeatherIcon";
import "./WeatherForecastDay.css";


export default function WeatherForecastDay(props) {
    function maxTemperature() {
        let temperature = Math.round(props.data.temp.max);
        return `${temperature}°C`;
    }

     function minTemperature() {
        let temperature = Math.round(props.data.temp.min);
        return `${temperature}°C | `;
    }

    function day() {
        let date = new Date(props.data.dt * 1000);
    let day = date.getDay();

    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return days[day];
    }
    
    
    return (
        <div>
        < hr />
        <div className="WeatherForecast-day">{day()}</div>
        <WeatherIcon code={props.data.weather[0].icon} size={36}/>
        <div className="WeatherForecase-temperature">
        <span className="WeatherForecast-temperature-min">{minTemperature()}</span>
        <span className="WeatherForecast-temperature-max">{maxTemperature()}</span>
        < hr />
        </div>
        </div>
    );
}